module.exports = __webpack_public_path__ + "static/media/Brochure2.90d3534e.png";